export function formatCount(value: number): string {
  if (value <= 0) return '0';
  return Math.floor(value).toLocaleString('en-US').replace(/,/g, ' ');
}

export function formatDataUsage(value: number): string {
  if (value <= 0) return '0 GB';
  return `${value.toLocaleString('en-US')} GB`;
}
